import script from "./vmsChangeUserInformation.vue?vue&type=script&lang=js"
export * from "./vmsChangeUserInformation.vue?vue&type=script&lang=js"

import "./vmsChangeUserInformation.vue?vue&type=style&index=0&id=357dd260&lang=css"
import "./vmsChangeUserInformation.vue?vue&type=style&index=1&id=357dd260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357dd260"]])

export default __exports__